<template>
  <SmPopover :contentWidth="184" class="share-visit">
    <template v-slot:trigger="{ togglePopover }">
      <slot :event="togglePopover"></slot>
    </template>

    <template v-slot:content="{ togglePopover }">
      <div class="share-visit__content">
        <div
          v-for="btn in shareButtons"
          :key="btn.title"
          class="share-visit__content--link"
          @click="btn.action(togglePopover)"
        >
          <component :is="btn.icon" />
          <span>{{ btn.title }}</span>
        </div>
      </div>
    </template>
  </SmPopover>
</template>
<script>
import { SmPopover } from '@/shared'

import CopyIcon from '@/assets/icons/copy'

export default {
  name: 'shareEventButton',
  props: ['shareText'],
  components: {
    SmPopover
  },
  setup(props) {
    const shareButtons = [
      {
        title: 'Скопировать ссылку',
        action: (closeAction) => {
          navigator.clipboard.writeText(window.location.href)
          closeAction()
        },
        icon: CopyIcon
      },
      {
        title: 'Скопировать данные о приёме',
        action: (closeAction) => {
          navigator.clipboard.writeText(props.shareText)
          closeAction()
        },
        icon: CopyIcon
      }
    ]

    return { shareButtons }
  }
}
</script>
<style lang="scss" scoped>
@import 'style';
</style>
